export enum Variant {
    Default = 'default',
    Primary = 'primary',
    Secondary = 'secondary',
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Danger = 'danger',
    Light = 'light',
    Dark = 'dark',
    Purple = 'purple',
    Pink = 'pink',
}

export enum ButtonVariant {
    Default = 'default',
    Primary = 'primary',
    Secondary = 'secondary',
    Success = 'success',
    Action = 'action',
    Icon = 'icon',
    // Info = 'info',
    Warning = 'warning',
    Danger = 'danger',
    // Light = 'light',
    // Dark = 'dark',
    Link = 'link',
    OutlinePrimary = 'outline-primary',
    OutlineSuccess = 'outline-success',
    OutlineWarning = 'outline-warning',
    OutlineDanger = 'outline-danger',
    // OutlineInfo = 'outline-info',
    // OutlineLight = 'outline-light',
    // OutlineDark = 'outline-dark',
}

export enum BadgeVariant {
    Default = 'default',
    Primary = 'primary',
    Secondary = 'secondary',
    Success = 'success',
    Warning = 'warning',
    Danger = 'danger',
    DangerDark = 'danger-dark',
    Suspect = 'suspect',
    New = 'new',
    Responded = 'responded',
    BrandPrimary = 'brand-primary',
    SentimentPositive = 'sentiment-positive',
    SentimentNeutral = 'sentiment-neutral',
    SentimentNegative = 'sentiment-negative',
    SentimentNone = 'sentiment-none',
    SentimentOther = 'sentiment-other',
    Abandoned = 'abandoned',
    Purple = 'purple',
    Pink = 'pink',
}

export enum Size {
    XSmall = 'xs',
    Small = 'sm',
    Large = 'lg',
    XLarge = 'xl',
}
